import { AccessRights } from 'src/app/features/role/user-role/user-role'
import { rolePermissionsSelectors } from './../role-permissions.selectors'
import { BulkAction } from 'src/app/shared/interfaces'

import {
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
  ViewChild
} from '@angular/core'
import { DataTable } from '@pascalhonegger/ng-datatable'

import { RolePermissions } from '../role-permissions'
import { Observable } from 'rxjs'
import { Dictionary } from '@ngrx/entity'
import { Store } from '@ngrx/store'
import { AppState } from 'src/app/core/core.state'
import { tap } from 'rxjs/operators'
import { productSelectors } from '../../product/product.selectors'
import { untilDestroyed, UntilDestroy } from '@ngneat/until-destroy'
@UntilDestroy()
@Component({
  selector: 'role-permissions-table',
  templateUrl: './table.component.html',
  styleUrls: ['./table.component.scss']
})
export class RolePermissionsTableComponent implements OnInit {
  @Input() tableData: RolePermissions[]
  @Input() bulkActions: BulkAction[] = []
  @Input() key: string = 'id'
  @Output() onBulkAction = new EventEmitter<any>()
  @Output() onClickRow = new EventEmitter<any>()
  @Output() onSelectedPage = new EventEmitter<any>()
  @Output() onSelectLimit = new EventEmitter<any>()
  @Output() onSearchTerm = new EventEmitter<any>()
  @Output() onSortedTable = new EventEmitter<any>()
  @Input() showPageFooter: boolean = false
  @Input() removeSearchTerm$: Observable<boolean>
  @Input() total: number
  @Input() showTotal = false
  @Input() pageCount: number
  @Input() activePage: number = 1
  @Input() limitPage: number = 10

  @ViewChild('dataTable', { static: true }) dataTable: DataTable

  public rolePermissionsEntities$: Observable<Dictionary<RolePermissions>>
  public sorted: string = 'asc'
  public mfRowsOnPage = 25
  public mfPages = 1
  public filterTerm: string = ''
  public allCheckedToggle: boolean = false
  public checkedIds: Map<number, boolean> = new Map()
  public accessRights = AccessRights

  constructor(private store: Store<AppState>) {}

  public ngOnInit() {
    this.rolePermissionsEntities$ = this.store.select(
      rolePermissionsSelectors.selectEntities
    )

    this.removeSearchTerm$?.pipe(untilDestroyed(this)).subscribe((remove) => {
      if (remove) {
        this.filterTerm = ''
      }
    })
  }

  public onRowClicked(row: RolePermissions) {
    this.onClickRow.emit(row)
  }

  public onCheckRow(targetRow: RolePermissions) {
    this.checkedIds.set(
      targetRow.id,
      !Boolean(this.checkedIds.get(targetRow.id))
    )
  }
  public getProductById(id: number) {
    return this.store.select(productSelectors.selectById, id)
  }

  public onToggleAllChecked() {
    this.allCheckedToggle = !this.allCheckedToggle

    this.dataTable.data.forEach((row) =>
      this.checkedIds.set(row.id, this.allCheckedToggle)
    )
  }
  public mfSelectPage(event) {
    this.dataTable.setPage(event, this.dataTable.rowsOnPage)
  }
  public onSortfieldClick(field) {
    this.sorted = this.sorted == 'asc' ? 'desc' : 'asc'
    this.onSortedTable.emit(field)
  }
  public mfSetSearchLimit(rowsOnPage) {
    let rowsOnPageChange: any = {
      currentValue: rowsOnPage,
      previousValue: this.dataTable.rowsOnPage
    }

    this.dataTable.ngOnChanges({ rowsOnPage: rowsOnPageChange })
    this.mfRowsOnPage = rowsOnPage
    this.calculatePages()
  }
  private calculatePages() {
    this.mfPages = Math.ceil(
      this.tableData?.length / this.dataTable?.rowsOnPage
    )
  }
  public onClickBulkAction(bulkOption: string) {
    const rows: Location[] = this.dataTable.data.filter((x) =>
      this.checkedIds.get(x.id)
    )

    if (rows.length > 0) {
      this.onBulkAction.emit({ action: bulkOption, items: rows })
    }
  }

  public onSearch(value) {
    if (this.showPageFooter) {
      this.onSearchTerm.emit(value)
    }
  }

  public selectPage(event) {
    this.onSelectedPage.emit(event)
  }
  public setNewSearch(event) {}
  public setSearchLimit(event) {
    this.onSelectLimit.emit(event)
  }
}
